import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromApp from '../../../store/app.reducers';
import { Store } from '@ngrx/store';
import { Clear } from './user-details.actions';
import { SET_LOGGED_IN, SetLoggedIn } from '../../../store/auth/auth.actions';
import { tap } from 'rxjs/operators';

@Injectable()
export class UserDetailsEffects {


    onLogout = createEffect(() => this.actions$.pipe(
        ofType(SET_LOGGED_IN),
        tap(({ loggedIn }: SetLoggedIn) => {
            if (!loggedIn) {
                this.store.dispatch(new Clear());
            }
        })
    ), { dispatch: false });

    constructor(private actions$: Actions,
        private store: Store<fromApp.AppState>) {
    }
}

